var XPortal = XPortal || {};
XPortal.GridSettings = (function () {
    var self = {
        DefViewTitle: '', models: [],
        Init: function (options, containerSrc) {
            var container = $(containerSrc);
            if (container.length < 1 || !options) return;
            options.defViewTitle = ((options.selectableGridOptions || {}).pageData || {}).defaultViewTitle ? normalizeSettingName(options.selectableGridOptions.pageData.defaultViewTitle) : normalizeSettingName(options.defViewTitle || "Default-view");
            var xmodel = self.GetNewModel(container, options);
            self.models[options.id] = xmodel;
            self.DefViewTitle = options.defViewTitle;
            for (var i = 1; i < arguments.length; i++)
                if ($(arguments[i]).length > 0) kendo.bind($(arguments[i]), xmodel);
            options.initSettingsStr = JSON.stringify(options.selectableGridOptions);

            XPortal.Navigation.MapRoute('#' + options.id + '/:actionid/:name', function () {
                var route = this.params;
                if (route.actionid === "v" || route.actionid === "e") {
                    var currentModel = self.models[options.id];
                    currentModel.onSelect(route.name);
                }
            }, "any");
            XPortal.Navigation.MapRoute($(options.remove).attr('action'), function () { return true; }, "any");
            XPortal.Navigation.MapRoute($(options.add).attr('action'), function () { return true; }, "any");
        },
        GetSettingsLinks: function (afterAction) {
            getLinksAsync({ NamesOnly: true }, function (response) {
                _.each(_.groupBy(response.Result, "NodeId"), function (group) {
                    var node = group[0].NodeId;
                    if (node !== response.Requested.PageId) {
                        var settingMenu = $("#sidebargv-items" + node);
                        if (settingMenu.length) {
                            XPortal.GridSettings.GetLinkModel(settingMenu, group);

                            if (group.length) {
                                settingMenu.closest('.menu-item-lvl-1').addClass('has-childs');
                            }
                        }
                    }
                });

                if (typeof afterAction === "function")
                    afterAction();

                XPortal.Sidebar.updateMenuItem();
            });
        },
        GetLinkModel: function (container, source) {
            var mainlink = XPortal.Sidebar.findMainLinkforGrids(container);
            if (!mainlink || mainlink.length === 0 || source === null)
                return;

            var link = mainlink.attr("href");
            var dataSource = new kendo.data.DataSource({
                transport:
                {
                    read: function (options) {
                        if (options.data.staticSource !== null) {
                            options.success(parseLinks(options.data.staticSource, link));
                        }
                        else {
                            getLinksAsync({ PageId: 0, NodeId: options.data.Node, NamesOnly: true },
                                function (response) { options.success(parseLinks(response.Result, link)); });
                        }
                    }
                }
            });
            dataSource.read({ staticSource: source });

            var lmodel = kendo.observable({
                templates: dataSource,
                isVisible: function () { return true; },
                remove: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    removelinkAsync({ Name: e.data.Name, NodeId: e.data.NodeId },
                        function (response) {
                            lmodel.set("initialized", response.Result !== null && response.Result.length > 0);
                            lmodel.templates.read({ staticSource: null, Node: response.Requested.NodeId });
                        });
                }
            });
            kendo.bind(container, lmodel);
            return lmodel;
        },
        GetDefaultView: function (options, isDefault) {
            return {
                index: 0,
                Title: options.DefViewTitle,
                FullTitle: (options.page.showPageTitle ? (options.page.title + " " + options.page.titleSeparator + " ") : "") + options.defViewTitle,
                NormalizedTitle: normalizeSettingName(options.defViewTitle),
                Comment: options.initSettingsStr,
                isBlank: true,
                linkUrl: '#' + options.id + "/v/" + normalizeSettingName(options.defViewTitle),
                isDivider: false,
                Node: options.id,
                isPlaceholder: true,
                IsDefault: isDefault
            };
        },
        GetNewModel: function (container, options) {
            var element = $("#entity-grid-" + options.id);
            if (element.length < 1) {
                if (console) console.error("entity-grid not found on page");
                return;
            }
            var dataSource = new kendo.data.DataSource({
                transport: {
                    read: function (ioptions) {
                        XPortal.Utils.APIPost(container.attr("data-src"), { model: Object.assign({}, options.page) })
                            .then(function (xdata) {
                                var xrdata = parseSettingsResult(xdata.Result, options);
                                ioptions.success(xrdata);
                            }, function (err, s, d) {
                                var xrdata = parseSettingsResult([], options);
                                ioptions.success(xrdata);
                            });
                    }
                },
                change: function (e) {
                    var currentModel = XPortal.GridSettings.models[options.id];
                    var setDefault = false;
                    if (currentModel.needToSetDefaultView) {
                        setDefault = currentModel.needToSetDefaultView;
                        var defView = e.items.find(v => v.IsDefault);
                        delete currentModel.needToSetDefaultView;
                    }
                    else defView = window.location.hash !== "" ? e.items.find(v => (v.linkUrl || "").toLowerCase() === window.location.hash.toLowerCase()) : e.items.find(v => v.IsDefault);
                    if (!defView) defView = e.items.find(v => v.IsDefault);
                    if (defView) {
                        var normTitle = defView.NormalizedTitle || normalizeSettingName(defView.Title);
                        currentModel.set("currentSName", normTitle);
                        var targetHash = '#' + options.id + "/v/" + normTitle;
                        if (window.location.hash !== targetHash && (setDefault || window.location.hash !== "" || !defView.isBlank)) {
                            XPortal.GridSettings.SetDefault(options.id);
                            if (window.location.hash !== targetHash)
                                currentModel.onSelect(normTitle);
                        }
                        else {
                            currentModel.onSelect(normTitle);
                        }
                        XPortal.DropdownBtns.gridButtons.checkWithTimeout($('.grid-action-header'));
                        return;
                    }
                    currentModel.set("currentSName", self.defaultView);
                    if (!currentModel.current)
                        currentModel.ensureSelected();
                    XPortal.DropdownBtns.gridButtons.checkWithTimeout($('.grid-action-header'));
                }
            });

            var xmodel = kendo.observable({
                templates: dataSource,
                current: null,
                isVisible: function () { return true; },
                ensureSelected: function (skiprefresh) {
                    if (this.get("currentSName") != null && !skiprefresh) xmodel.onSelect(xmodel.currentSName);
                    if (this.get("currentSName") == null) xmodel.onSelect(self.defaultView);
                },
                onSelect: function (name) {
                    this.set("currentSName", name);
                    var settingsObj = {};

                    var settings = _.find(xmodel.templates._data, function (d) { return (d.NormalizedTitle || "").toLowerCase() === (name || "").toLowerCase(); });
                    if (!settings && xmodel.templates._data.length > 0) settings = xmodel.templates._data[0];
                    if (settings) {
                        this.set("current", settings);
                        settingsObj = settings.Comment ? JSON.parse(settings.Comment) : {};
                        settingsObj.pageData = {};//clear page info - it should be taken from page directly
                        settingsObj.columns = ensureColumnsExists(options.selectableGridOptions, settingsObj.columns);
                        settingsObj.dataSource.filter = ensureFilterFieldNames(options.selectableGridOptions, settingsObj.dataSource.filter);
                    } else {
                        settingsObj = settingsObj ? settingsObj : {};
                        this.set("current", self.GetDefaultView(options));
                    }

                    if (settingsObj && settingsObj.dataSource && settingsObj.dataSource.sort && settingsObj.dataSource.sort.field) {
                        settingsObj.dataSource.sort = [settingsObj.dataSource.sort];//to merge sorting correctly
                    }
                    var ginfo = XPortal.Grid.GetGridInfo(element);
                    var findSelCol = function (c) { return c.field === "selectable"; };
                    var result = {};
                    if (!ginfo.kgrid) {
                        result = ginfo.kgrid == null ? options.selectableGridOptions : $.extend(true, options.selectableGridOptions, /*{ dataSource: { filter: [], sort: [], group: [] } }, */settingsObj);
                        try {
                            //if (Array.isArray(options.selectableGridOptions.dataSource.group) && options.selectableGridOptions.dataSource.group.length == 1)
                            //    options.selectableGridOptions.dataSource.group = options.selectableGridOptions.dataSource.group[0];
                            options.selectableGridOptions.columns = options.selectableGridOptions.columns.filter(c => c.field !== "selectable");//remove sel.column - it always should be rewriten
                            XPortal.Grid.InitSelectableGrid(element, options.selectableGridOptions, settingsObj);
                        }
                        catch (e) { if (console) console.error("InitSelectableGrid Init Error.", e); }
                    }
                    ginfo = XPortal.Grid.GetGridInfo(element, ginfo);
                    if (ginfo.kgrid != null) {
                        var editModeAction = ginfo.actionsHeader.find("[data-action=EditMode]");
                        if (editModeAction && editModeAction.length) XPortal.GridInlineEditing.SetEditMode(element, "grid-detail", editModeAction);
                        var curopts = ginfo.kgrid.getOptions();
                        result = $.extend(true, { columns: [], dataSource: { fields: [], filter: [], sort: [], group: [] } }, settingsObj);
                        var ensureVisible = function (c, exists) {
                            if (exists) return c;
                            if (c.hidden) {
                                c.hidden = false;
                                if (c.attributes && c.attributes.style) c.attributes.style = "";
                                if (c.footerAttributes && c.footerAttributes.style) c.footerAttributes.style = "";
                                if (c.headerAttributes && c.headerAttributes.style) c.headerAttributes.style = "";
                            }
                            return c;
                        };
                        if (curopts && curopts.columns) {

                            var selCol = _.find(curopts.columns, findSelCol);
                            var setCol = _.find(settingsObj.columns, findSelCol);
                            if (selCol && (!(_.find(result.columns, findSelCol)))) {
                                result.columns = [ensureVisible(selCol, setCol)].concat(result.columns);

                            }
                            var selFld = _.find(curopts.dataSource.fields, findSelCol);
                            var setFld = _.find(curopts.dataSource.fields, findSelCol);
                            if (selFld && (!(_.find(result.dataSource.fields, findSelCol)))) result.dataSource.fields = [ensureVisible(selFld, setFld)].concat(result.dataSource.fields);
                        }
                    }
                    //in some way now  result.dataSource.schema can be empty  - settingsObj is cleared so i add this check
                    if (result.dataSource && result.dataSource.schema && result.dataSource.schema.model) {
                        _.each(result.dataSource.schema.model.fields, function (f) {
                            var column = _.find(result.columns, function (x) { return x.field === f.field; });
                            if (!column) return;
                            XPortal.Grid.BindEditors(f, column);
                        });
                    }
                    if (ginfo.kgrid && XPortal.GridInlineEditing) {
                        try {
                            XPortal.GridInlineEditing.Init(ginfo, result);
                        }
                        catch (ex) {
                            if (console) console.error("GridInlineEditing Init Error.", ex);
                        }
                    }
                    if (ginfo.kgrid) {
                        let filters = result.filters || {};
                        XPortal.Facets.RestoreFrom(ginfo, filters.facets, filters.treeFacets);
                        var gridId = XPortal.GridCalendar.GetGridId($(element));
                        var view = XPortal.GridCalendar.GetCurrentView(gridId);
                        var columnStrategy = XPortal.GridCalendar.ResolveColumnStrategy(view);
                        var columns = [];
                        if (columnStrategy !== undefined) {
                            columns = columnStrategy(XPortal.GridCalendar.GetCurrentDate(gridId), gridId);
                        }
                        result.columns = result.columns.concat(columns);
                        XPortal.GridActions.actionmodels[gridId].set("filters", []);
                        if (!result.gridFilterViewModel) result.gridFilterViewModel = {};
                        result.gridFilterViewModel.filters = [];
                        ginfo.kgrid.setOptions(result);
                        XPortal.GridActions.ReactiveContentView(ginfo);

                        XPortal.DynamicFilters.RestoreFrom(ginfo, filters.dynamicFilters);
                    }

                    if (ginfo.kgrid && ginfo.kgrid.options && ginfo.kgrid.options.dataSource && ginfo.kgrid.options.dataSource.filter) {
                        let filtered = ginfo.kgrid.options.dataSource.filter.filters ? ginfo.kgrid.options.dataSource.filter.filters.length > 0 : false;
                        if (ginfo.nodeId) XPortal.GridActions.actionmodels[ginfo.nodeId].set("filtered", filtered);
                    }
                },
                remove: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    removelinkAsync({ Name: e.data.Name, NodeId: e.data.NodeId }, function (data, status, xhr) { updatesettings(data.Requested.NodeId); })

                },
                setDefault: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    let url = container.attr("set-default-src");
                    let options = {
                        DefaultUid: e.data.UniqueId ? e.data.UniqueId : "00000000-0000-0000-0000-000000000000",
                        NodeId: e.data.NodeId ? e.data.NodeId : e.data.Node,
                        Alias: e.data.EntityAlias
                    };
                    XPortal.Utils.APIPost(url, options)
                        .then(function (data) {
                            window.location.hash = "";
                            updatesettings(data.Requested.NodeId);
                            $grid = $('#entity-grid-' + data.Requested.NodeId);
                            $grid.length && XPortal.Grid.ResizeGrid($grid);
                        });
                },
                onReset: function () {
                    //this.onSelect(this.get("currentSName"));
                }
            });
            return xmodel;
        },
        OnShowSettingsFormAjaxComplete: function (response, status, xhr, gridSelector) {
            XPortal.Main.OnPortalFormAjaxComplete(response, status, xhr);
            //setTimeout(function () { $("input#Name").trigger('focus'); }, 300); Complete set focus after modal displayed (debug checkIfModal)
            $("#savegridsettings-form").on("click", "button[type='submit']", function (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                const grid = gridSelector && gridSelector.length ? $(gridSelector) : $(".k-grid");
                const form = $(this).closest("form");
                if (grid) {
                    const options = grid.data("kendoGrid").getOptions();
                    const gInfo = XPortal.Grid.GetGridInfo(grid);
                    options.dataCvKey = gInfo.kgrid.dataSource.isListView ? (gInfo.list.attr("data-cvkey") || "") : "b2grid";
                    ensureDynamicFilters(gInfo, options);
                    form.find(".settings").val(kendo.stringify(options));
                }

                const title = form.find(".save-settings-title").text();
                const content = form.find(".save-settings-content").text();
                const targetId = form.attr("data-target");
                let newViewName = XPortal.GridSettings.DefViewTitle;
                if (!form.valid()) return;
                $.ajax({
                    type: "post",
                    url: XPortal.Utils.EnsureInProfile(form.attr("action")),
                    data: form.serializeArray(),
                    success: function (response) {
                        if (response.State < 0) {
                            XPortal.Modal.alert({
                                headerText: title,
                                alertText: content
                            });
                        } else {
                            newViewName = response.Result[0].Title;
                            XPortal.GridSettings.ClearSessionFilter(targetId);
                            var updateId = form.attr("data-ajax-update");
                            if (updateId) $(updateId).replaceWith("");
                            XPortal.Modal.closeModal(form);
                            XPortal.Sidebar.updateMenuItem();
                        }
                    }
                }).done(function () {
                    updatesettings(targetId, function () {
                        window.location.hash = '#' + targetId + "/v/" + XPortal.GridSettings.Normalize(newViewName);
                    });

                });
            });
        },
        ClearSessionFilter: function (id) {
            var model = XPortal.GridSettings.models[id];
            var defViewLink = "/v/" + self.DefViewTitle;
            var key = window.location.href + id + "_" + XPortal.Account.Name;
            if (window.location.hash === ""
                && model && model.current && model.current.linkUrl.indexOf(defViewLink) > -1) {
                key1 = window.location.href + model.current.linkUrl + id + "_" + XPortal.Account.Name;
                clientSessionfilter = sessionStorage.getItem(key1);
                if (clientSessionfilter) sessionStorage.removeItem(key1);
            }
            clientSessionfilter = null;
            var clientSessionfilter = sessionStorage.getItem(key);
            if (clientSessionfilter) sessionStorage.removeItem(key);
        },
        SetDefault: function (blockId) {
            if (self.isPageDetail == null) ensureIsDetailPage();
            const hshqf = getParameterByName("hshqf");
            const rsst = getParameterByName("rsst");
            if (self.isPageDetail || hshqf || rsst)
                return;
            var xmodel = self.models[blockId];
            if (!xmodel) return;
            const qstr = window.location.search || "";
            var targetName = xmodel.currentSName ? xmodel.currentSName : self.defaultView;
            var targetHash = '#' + blockId + "/v/" + targetName;
            if (window.location.hash == targetHash)
                xmodel.onSelect(targetName);
            else
                XPortal.Navigation.Redirect(qstr + targetHash);
        },
        Normalize: function (name) { return normalizeSettingName(name); }
    };

    function ensureIsDetailPage() {
        self.isPageDetail = false;
        const pageModels = XPortal.Store.GetState().pageModels;
        for (var mkey in pageModels) {
            if (((pageModels[mkey].model || { modelPath: "" }).modelPath || "").startsWith(">>PM."))
                self.isPageDetail = true;
        }
    };

    function ensureColumnsExists(existingData, savedColumns) {//update column list based on existing settings
        var existingColumns = existingData.columns;
        var res = [];
        if (!savedColumns || savedColumns.length === 0) res = [];
        else
            savedColumns.forEach(function ({ field, encoded, locked, hidden }) {
                hidden = hidden ? true : false;
                var x = existingColumns.find(function (c) { return field == c.field; });
                if (x) res.push($.extend(true, {}, x, { encoded, locked, hidden }));
            });
        if (res.length < 1) res = existingColumns.map(function (x) {
            return $.extend(true, {}, x);
        });
        return res;
    };
    function ensureFilterFieldNames(existingData, filtersToCheck) {
        return filtersToCheck;//here we have to check that filter columns still present in model
    };
    function updatesettings(targetId, afterReadFunc) {
        var observable = XPortal.GridSettings.models[targetId];
        if (observable) {
            observable.justUpdated = true;
            observable.templates._requestInProgress = false;
            observable.templates.read().then(function () {
                if (afterReadFunc) afterReadFunc();
            });
        }
    }

    function parseSettingsResult(result, options) {
        const source = [];
        const hshqf = getParameterByName("hshqf");
        const rsst = getParameterByName("rsst");
        source.push(XPortal.GridSettings.GetDefaultView(options, false));
        if (!result || result.length < 1) {
            source[0].IsDefault = true;
            return source;
        }
        $.each(result, function (i, xval) {
            source.push(xval);
            xval.index = i + 1;
            xval.isDefault = false;
            xval.NormalizedTitle = normalizeSettingName(xval.Title);
            xval.linkUrl = '#' + options.id + "/v/" + xval.NormalizedTitle;
            xval.isCurrent = false;
            xval.Title = xval.Title;
            xval.FullTitle = (options.page.showPageTitle ? (options.page.title + " " + options.page.titleSeparator + " ") : "") + xval.Title;
        });
        const observable = XPortal.GridSettings.models[options.id];
        const justUpdated = observable.justUpdated;

        if ((!justUpdated ? true : false) && (hshqf || rsst ? true : false)) source.forEach(x => x.IsDefault = false);
        if (!source.find(s => s.IsDefault === true)) source[0].IsDefault = true;
        observable.justUpdated = false;
        return source;
    }
    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    function parseLinks(response, mainLink) {
        var source = [];
        if (response.length > 0) {
            var allView = {
                index: 1,
                isDefault: false,
                NormalizedTitle: normalizeSettingName("All"),
                linkUrl: mainLink + '#' + response[0].NodeId,
                Title: "All",
                Name: "All"
            };
            source.push(allView);
        }
        $.each(response, function (i, xval) {
            source.push(xval);
            xval.index = i + 1;
            xval.isDefault = false;
            xval.NormalizedTitle = normalizeSettingName(xval.Title);
            xval.linkUrl = mainLink + '#' + xval.NodeId + "/v/" + xval.NormalizedTitle;
        });
        return source;
    }

    function getLinksAsync(data, onSuccess) {
        XPortal.Utils.APIPost($("#sidebar-menu").attr("data-usersettings"), data)
            .then(onSuccess);
    }

    function removelinkAsync(data, onSuccess) {
        var onconfirmation = function (params) {
            if (params.result === "yes") {
                XPortal.Utils.APIPost($("#sidebar-menu").attr("data-removesettings"), data)
                    .then(onSuccess);
            }
        };

        var params = {
            options: {
                headerText: $("#sidebar-menu").attr("data-settingModalTitle"),
                confirmationText: $("#sidebar-menu").attr("data-delSettingConfirmMsg"),
                buttonsText: [$("#sidebar-menu").attr("data-no-btn"), $("#sidebar-menu").attr("data-yes-btn")]
            },
            result: "no"
        };

        XPortal.Modal.confirm(params, onconfirmation);
    }

    function ensureDynamicFilters(ginfo, options) {
        const fsets = (XPortal.DynamicFilters.GridFilterSetsPairs[ginfo.nodeId] || {}).fsets;

        options.filters.dynamicFilters.forEach(x => {
            const fsetModelName = (fsets.find(f => f.id == x.uid) || {}).modelName;
            const mfields = ((XPortal.Store.GetModelByName(fsetModelName) || {}).entity || {}).Fields;

            if (x.entity && x.entity.Fields) {
                x.entity.Fields.forEach(f => {
                    const fnamelc = f.Field.toLowerCase();
                    let newVal = (mfields.find(mf => mf.Name.toLowerCase() == fnamelc) || {}).StringValue;

                    if (newVal && newVal.length) {
                        f.Data = newVal;
                    }
                });
            }
        });

        return options;
    }

    function normalizeSettingName(name) { return name.replace(/[^\w\d\u0400-\u04FF\u00C0-\u00FF]/g, "-"); }

    return self;
}());